module.exports = __webpack_public_path__ + "static/Screenshot (66)-133ba5b493b4abc54e4fe09e75c01280.png";